import styled from 'styled-components'

const FONT_SIZE = {
  sm: '12px',
  md: '14px',
}


export const _MessageContainer = styled.div`
  width: 100%;
  border-radius: 10px;
  > div, span {
    line-height: 16px;
    font-size: ${({ fontSize }) => FONT_SIZE[fontSize]};
  }
  span {
    color: #037888 !important;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

  // all the site use same color
  ${({ requireBackground }) => (requireBackground && `
    padding: 14px;
    background-color: #E7F3F4;
    border: 1px solid #037888;

 `)}
`
